module.exports = __webpack_public_path__ + "img/FachadaBristol-3.aa193de8.jpg";